<p-fieldset legend="Change Password">
    <div class="form-wrapper">
            <form [formGroup]="changePasswordFormGroup" class="changepw-form" (ngSubmit)="onSubmit()">
                <div class="field">
                    <label for="current-password">Current Password</label>
                    <p-password
                        id="current-password"
                        formControlName="currentPassword"
                        name="current-password"
                        class="w-full"
                        [toggleMask]="true"
                        [feedback]="false"
                        inputStyleClass="w-full"
                        autocomplete="current-password"
                    ></p-password>
                </div>

                <div class="field">
                    <label for="new-password">New Password</label>
                    <p-password
                        id="new-password"
                        formControlName="newPassword"
                        name="new-password"
                        class="w-full"
                        [toggleMask]="true"
                        [feedback]="true"
                        inputStyleClass="w-full"
                        autocomplete="none"
                    >
                     <ng-template pTemplate="content">
                        <ul class="password-hints">
                            <li [class.valid]="passwordState.hasMinLength">Minimum 8 characters long</li>
                            <li [class.valid]="passwordState.hasUpper">At least one uppercase letter</li>
                            <li [class.valid]="passwordState.hasLower">At least one lowercase letter</li>
                            <li [class.valid]="passwordState.hasNumber">At least one number</li>
                            <li [class.valid]="passwordState.hasSpecial">At least one special character</li>
                        </ul>
                    </ng-template>
                </p-password>
                </div>

                <div class="field">
                    <label  for="confirm-password">Confirm new Password</label>
                    <p-password
                        id="confirm-password"
                        formControlName="confirmPassword"
                        name="confirm-password"
                        toggleMask="true"
                        feedback="false"
                        class="w-full"
                        inputStyleClass="w-full"
                        autocomplete="none"
                    ></p-password>
                </div>

                <p-button
                    type="submit"
                    label="Change Password"
                    icon="pi pi-user-edit"
                    severity="secondary"
                    [loading]="loading()"
                    [disabled]="!changePasswordFormGroup.valid"
                ></p-button>
            </form>
    </div>
</p-fieldset>